export const ECONOMIC_CALENDAR_API_URL = '/api/calendar/economic'
export const EARNINGS_CALENDAR_API_URL = '/api/calendar/earnings'
export const DIVIDENDS_CALENDAR_API_URL = '/api/calendar/dividends'
export const ISO_DATEONLY_FORMAT = 'yyyy-MM-dd'

export enum CalendarView {
  Economic = 'economic',
  Detail = 'detail',
  Earnings = 'earnings',
  Dividends = 'dividends',
}

export enum CalendarViewParam {
  // NOTE: index
  DateFrom = 'dateFrom',
  // NOTE: detail
  Ticker = 'ticker',

  // NOTE: earnings / dividends
  Sort = 'sort',
  Page = 'page',
}

export interface CalendarViewsParams {
  [CalendarView.Economic]: {
    [CalendarViewParam.DateFrom]: Date
  }
  [CalendarView.Detail]: {
    [CalendarViewParam.Ticker]: string | null
  }
  [CalendarView.Earnings]: {
    [CalendarViewParam.DateFrom]: Date
    [CalendarViewParam.Page]: number
    [CalendarViewParam.Sort]?: string
  }
  [CalendarView.Dividends]: {
    [CalendarViewParam.DateFrom]: Date
    [CalendarViewParam.Page]: number
    [CalendarViewParam.Sort]?: string
  }
}

export const CalendarViewHasParams: Record<CalendarView, CalendarViewParam[]> = {
  [CalendarView.Economic]: [CalendarViewParam.DateFrom],
  [CalendarView.Detail]: [CalendarViewParam.Ticker],
  [CalendarView.Earnings]: [CalendarViewParam.DateFrom, CalendarViewParam.Sort, CalendarViewParam.Page],
  [CalendarView.Dividends]: [CalendarViewParam.DateFrom, CalendarViewParam.Sort, CalendarViewParam.Page],
}

export const CALENDAR_VIEW_LABELS = {
  [CalendarView.Economic]: 'Economic',
  [CalendarView.Earnings]: 'Earnings',
  [CalendarView.Dividends]: 'Dividends',
}
